<template>
  <div id="page">
    <div id="videoFrame"></div>
    <transition name="fade"><div id="header" v-if="!plays"></div></transition>
    <transition name="fade"><div id="videoStarter" @click="play" v-if="!plays || pause"></div></transition>
    <about></about>
    <media></media>
    <contact></contact>
    <vfooter @showImprint="showImprint"></vfooter>
    <imprint v-if="imprint"></imprint>
  </div>
</template>

<script>
import Player from '@vimeo/player'

export default {
  data () {
    return {
      options: {
        id: 226375994,
        width: window.innerWidth,
        height: window.innerWidth > 540 ? window.innerHeight : 200,
        title: false,
        byline: false,
        portrait: false,
        transparent: true
      },
      player: null,
      plays: false,
      pause: false,
      imprint: false
    }
  },

  mounted () {
    this.player = new Player('videoFrame', this.options)

    this.player.on('pause', () => {
      this.pause = true
    })

    this.player.on('play', () => {
      this.plays = true
      this.pause = false
    })

    this.player.on('ended', () => {
      this.plays = false
      this.pause = false
    })
  },

  ready: function () {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    play () {
      this.player.play()
    },
    showImprint () {
      this.imprint = true
      this.$scrollTo('#imprint')
    },
    handleResize () {
      // TODO
      console.log('resized')
    }
  }
}
</script>

<style lang="scss" scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  #videoFrame {
    background-color: #0d0d0d;
    @media all and (max-width: 540px) {
      margin-top: 50px;
    }

    .vp-sidedock {
      display: none !important;
    }
  }

  #header {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    background: url("../assets/header.jpg") no-repeat center;
    background-size: 100% auto;
    @media all and (max-width: 540px) {
      height: 200px;
      margin-top: 50px;
    }
  }

  #videoStarter {
    position: absolute;
    top: 40%;
    left: 45%;
    width: 150px;
    height: 150px;
    border: 10px solid white;
    -webkit-border-radius: 100%;
    -moz-border-radius: 100%;
    border-radius: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    cursor: pointer;

    &::before {
      content: "";
      width: 0;
      height: 0;
      -webkit-transform: rotate(360deg);
      border-style: solid;
      border-width: 30px 0 30px 60px;
      border-color: transparent transparent transparent white;
      top: 38%;
      position: relative;
      left: 33%;
      font-size: 0;
    }

    @media all and (max-width: 540px) {
      top: 100px;
      left: 40%;
      width: 100px;
      height: 100px;
      border: 5px solid white;

      &:before {
        top: 31%;
        border-width: 20px 0 20px 40px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main.vue